import React from "react";
import "./Footer.css";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaChevronRight,
  FaMapMarkerAlt,
} from "react-icons/fa";
import {  FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ================= ABOUT ================= */}
        <div className="footer-col">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          <p className="footer-about">
            PFA LOGISTICS PVT LTD was founded in 2009 by a team of
            professionals with extensive experience in India’s express and
            logistics industry. 
          </p>
        </div>

        {/* ================= SERVICES ================= */}
        <div className="footer-col">
          <h4>Our Service</h4>
          <ul className="footer-links-list">
            <li><FaChevronRight /> Cash On Delivery</li>
            <li><FaChevronRight /> One Ship / Ware Housing</li>
            <li><FaChevronRight /> Prepaid Delivery</li>
            <li><FaChevronRight /> Reverse Pickup</li>
            <li><FaChevronRight /> Same Day Delivery</li>
          </ul>
        </div>

        {/* ================= COMPANY ================= */}
        <div className="footer-col">
          <h4>Our Company</h4>
          <ul className="footer-links-list">
            <li><FaChevronRight /><Link to="/">Home</Link></li>
            <li><FaChevronRight /><Link to="/about">About Us</Link></li>
            <li><FaChevronRight /><Link to="/tracking">Tracking</Link></li>
            <li><FaChevronRight /><Link to="/services">Services</Link></li>
            <li><FaChevronRight /><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* ================= CONTACT ================= */}
       <div className="footer-box">
          <h4>Contact Info</h4>

          <p className="contact-item">
  <FaPhoneAlt />
  <span className="contact-text">
    <a href="tel:+919810123883" className="contact-link">
      +91-981-012-3883
    </a>
    <a href="tel:+919616650556" className="contact-link">
      +91-961-665-0556
    </a>
  </span>
</p>

<p className="contact-item">
  <FaEnvelope />
  <span className="contact-text">
    <a href="mailto:pfa@alogistics.co.uk" className="contact-link">
      pfa@alogistics.co.uk
    </a>
    <a href="mailto:info@pfalogistics.com" className="contact-link">
      info@pfalogistics.com
    </a>
    <a href="mailto:vijay.sehrawat@pfalogistics.com" className="contact-link">
      vijay.sehrawat@pfalogistics.com
    </a>
  </span>
</p>

        <p ><FaMapMarkerAlt className="map-icon pulse-pin" />
          <a 
           href="https://www.google.com/maps?q=333/1+DAYA+COMPLEX+RANGPURI+NEW+DELHI+110037"
           target="_blank"
           rel="noopener noreferrer"
           className="map-link"
           >
            333/1 DAYA COMPLEX RANGPURI NEAR TATA TELCO NEW DELHI 110037
          </a>
        </p>

           <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaXTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaInstagram /></a>
          </div>

        </div>
        

      </div>

      {/* ================= FOOTER BOTTOM ================= */}
      <div className="footer-bottom">
        <p>© 2026,  PFA LOGISTICS PVT LTD . All Rights Reserved</p>

        <div className="footer-bottom-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
